import { render, staticRenderFns } from "./Pieecharts.vue?vue&type=template&id=33b5dbd2&scoped=true&"
import script from "./Pieecharts.vue?vue&type=script&lang=js&"
export * from "./Pieecharts.vue?vue&type=script&lang=js&"
import style0 from "./Pieecharts.vue?vue&type=style&index=0&id=33b5dbd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b5dbd2",
  null
  
)

export default component.exports